<script setup >
import { onMounted, ref, watch } from 'vue';
import tippy from 'tippy.js';

const {title, placement, onClick} = defineProps({
  title: String,
  placement: String,
  onClick: Function
})

const emit = defineEmits(['action'])
const handled = ref(false)
const node = ref(null)
watch(
  () => title,
  (newTitle) => {
    if (tippyInstance) {
      tippyInstance.setContent(newTitle);
    }
  }
);

let tippyInstance;
onMounted(() => {
  if (title) {
    tippyInstance = tippy(node.value, {
      content: title,
      placement: placement || 'bottom', 
      onShow(instance) {      
        instance.popper.style.zIndex = '9999';
      },
      touch: false
    });
  }
}) 

</script>
<!-- <template>
  <button 
    class="btn" ref="node" 
    @pointerdown="() => {console.log('pointerdown'); handled = false}"
    @pointerup="e => {console.log('pointerup'); handled = true; emit('action', e)}" 
    @click="e => {console.log('click'); if (!handled) {handled = true; emit('action', e)}}" 
  ><slot /></button>
</template> -->
<template>
  <button 
    class="btn" ref="node" 
    @click="e => emit('action', e)" 
  ><slot /></button>
</template> 